import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  logOut: () => void;
};

const LogoutButton: React.FC<Props> = ({ logOut }) => {
  const { t } = useTranslation('global');

  return (
    <button
      onClick={logOut}
      style={{ marginTop: '1rem', background: '#800080', color: 'white' }}
    >
      {t('navigation.log_out')}
    </button>
  );
};

export default LogoutButton;
